
import React from 'react';
import SEOMetaTags from '@/components/SEOMetaTags';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';

const SecurityPage = () => {
  return (
    <div className="flex min-h-screen flex-col bg-synthreo-black text-white">
      <SEOMetaTags 
        title="Security Protocols | Synthreo"
        description="Our comprehensive security protocols to protect your data and AI models."
        url="https://synthreo.ai/security"
      />
      <Navbar />
      <main className="flex-grow w-full">
        <section className="container mx-auto px-4 py-24">
          <h1 className="text-4xl font-bold mb-8 font-gilroy">
            Enterprise-Grade Security Protocols
          </h1>
          <div className="prose prose-invert max-w-4xl">
            <p className="text-xl text-gray-300 mb-6">
              At Synthreo, we take security seriously. Our comprehensive approach ensures 
              the protection of your data, AI models, and intellectual property.
            </p>
            {/* Add more detailed security information here */}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SecurityPage;
